<template>
  <div class="interactive-report-map">
    <google-map
      ref="googleMap"
      @ready="googleMapReady"
      @geometry-clicked="geometryClicked"
    ></google-map>
  </div>
</template>

<script>
import GoogleMap from '@/components/Maps/Google'

export default {
  name: 'interactive-report-map',
  props: {
    travelSteps: Array
  },
  computed: {
    polylineOptions: function () {
      const polylineOptions = {
        path: []
      }
      for (const step of this.travelSteps) {
        polylineOptions.path.push(step.latLng)
      }
      return polylineOptions
    },
    markersOptions: function () {
      const markersOptions = []
      for (const step of this.travelSteps) {
        markersOptions.push({
          position: step.latLng,
          data: {
            eventId: step.eventId
          }
        })
      }
      return markersOptions
    }
  },
  watch: {
    travelSteps: function () {
      this.setUpTravel()
    }
  },
  components: {
    'google-map': GoogleMap
  },
  methods: {
    googleMapReady: function () {
      if (this.travelSteps.length > 0) {
        this.setUpTravel()
      }
    },
    geometryClicked: function (geometry) {
      if (geometry.type !== 'Marker') {
        return false
      }
      this.$emit('open-event-dialog', { eventId: geometry.data.eventId })
    },
    setUpTravel: function () {
      // Handle empty travel
      if (this.travelSteps.length === 0) {
        console.log('No hay eventos para mostrar')
        return false
      }
      const googleMap = this.$refs.googleMap
      googleMap.removeMarkers()
      googleMap.removePolylines()
      const polyline = googleMap.createPolyline({
        polylineOptions: this.polylineOptions
      })
      googleMap.setGeometryToMap(polyline)
      for (const markerOptions of this.markersOptions) {
        const marker = googleMap.createMarker({ markerOptions })
        googleMap.setGeometryToMap(marker)
      }
      const lastTravelStep = this.travelSteps[this.travelSteps.length - 1]
      googleMap.panTo(lastTravelStep.latLng)
    }
  }
}
</script>

<style lang="sass" scoped>
.interactive-report-map
  height: calc(100vh - 132px)
  margin: 0
  padding: 0
</style>



// WEBPACK FOOTER //
// src/components/Travels/Map.vue